import { Card, Heading } from '@digdir/designsystemet-react';
import './imageTextBox.css';
import React from 'react';
import { ImageData } from './../CommonTypes';
import { RichText } from '@enonic/react-components';

interface ImageTextBoxType {
	title: string;
	text: TextAndImageBoxText;
	url: string;
	imageData: ImageData;
	odd: boolean;
}

interface TextAndImageBoxText {
	processedHtml: string;
	macros: any[];
	images: any[];
	links: any[];
	macroComponents: any[];
}

export const ImageTextBox = ({ props }: { props: ImageTextBoxType }) => {
	return (
		<>
			<img src={props.imageData.url} alt={props.imageData.altText} />

			{props.url ? (
				<Card asChild>
					<a href={props.url}>
						{props.title && (
							<Card.Block>
								<Heading>{props.title}</Heading>
							</Card.Block>
						)}

						{props.text && (
							<Card.Block>
								<RichText data={props.text} />
							</Card.Block>
						)}
					</a>
				</Card>
			) : (
				<Card>
					{props.title && (
						<Card.Block>
							<Heading>{props.title}</Heading>
						</Card.Block>
					)}

					{props.text && (
						<Card.Block>
							<RichText data={props.text} />
						</Card.Block>
					)}
				</Card>
			)}
		</>
	);
};
